import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';
import { ROUTES } from '../constants/routes';

interface ProtectedRouteProps {
  requireAdmin?: boolean;
}

/**
 * ProtectedRoute component
 * Wrapper for routes that require authentication
 * Redirects to login if user is not authenticated
 * Optionally checks for admin privileges
 */
export const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ requireAdmin = false }) => {
  const { userData, isLoading } = useAuth();

  // Show loading state while checking auth
  if (isLoading) {
    return (
      <div className="fullpage-loading">
        <div className="fullpage-loading-spinner"></div>
        <div className="fullpage-loading-text">Loading...</div>
      </div>
    );
  }

  // Check if user is authenticated (userData has been populated)
  const isAuthenticated = userData.userAddress !== null || userData.isAdmin !== null;

  // Redirect to login if not authenticated
  if (!isAuthenticated) {
    return <Navigate to={ROUTES.LOGIN} replace />;
  }

  // Check admin requirement
  if (requireAdmin && !userData.isAdmin) {
    return <Navigate to={ROUTES.DASHBOARD} replace />;
  }

  // Render child routes
  return <Outlet />;
};
